import { FuseNavigationItem } from '@fleet/model';

export const fleetFlexNavigation: FuseNavigationItem[] = [
  {
    id: 'driver',
    title: 'drivers',
    icon: 'person',
    link: '/driver',

    type: 'basic',
  },
  {
    id: 'job',
    title: 'job',
    icon: 'place',
    link: '/job',
    type: 'basic',
  },
  {
    id: 'organisation',
    title: 'organisations',
    icon: 'business',
    link: '/organisation',

    type: 'basic',
  },
  {
    id: 'traveller',
    title: 'travellers',
    icon: 'hail',
    type: 'basic',
    link: '/traveller',
  },
  {
    id: 'job.active',
    title: 'activeJobs',
    type: 'basic',
    icon: 'stream',
    link: '/job/active',
    securityFunctions: ['JOB_ACTIVITY:read'],
  },
  {
    id: 'vehicle.fleet',
    title: 'activeVehicles',
    type: 'basic',
    icon: 'radar',
    link: '/vehicle/fleet',
    exactMatch: true,
    securityFunctions: ['VEHICLE_ACTIVE_SEARCH:read'],
  },
  {
    id: 'duress',
    title: 'duress',
    type: 'basic',
    icon: 'crisis_alert',
    link: '/duress',
    securityFunctions: ['DURESS_SEARCH:read'],
  },
];
